import { css } from '@emotion/core';

export const customerStatFilterButtonContainerCSS = css`
    height: 2.5rem;
    display: inline-flex;
    justify-content: center;
    align-items: center;
`;

export const customerStatFilterButtonCSS = ({ colors }) => css`
    border-radius: 0.5rem;
    height: 2.3rem;
    width: 2.3rem;
    border: 0.1rem solid ${colors.neutral80};

    > svg {
        color: ${colors.neutral10};
        &:hover,
        &:active,
        &:focus {
            color: ${colors.neutral10};
        }
    }

    &:hover,
    &:active,
    &:focus {
        border: 0.1rem solid ${colors.neutral80};
        background-color: ${colors.neutral95};
    }
`;
export const customerStatFilterByApplicationSeeMoreCSS = css`
    display: flex;
`;

export const customerStatFilterContainerCSS = css`
    display: flex;
    height: 100%;
`;

export const customerStatFilterTopDownContainerCSS = css`
    display: block;
`;
